const actionChannel = new BroadcastChannel("action_channel");

export const sendLogoutBroadcast = () => {
    actionChannel.postMessage({ type: "LOGOUT" });
};

export const broadcastActionEvent = (type, payload = null) => {
    actionChannel.postMessage({ type, payload });
};

export const onActionBroadcast = (handlers = {}) => {
    actionChannel.onmessage = (event) => {
        const { type, payload } = event.data;

        if (type === "LOGIN" && handlers.onLogin) {
            handlers.onLogin(payload);
        }

        if (type === "LOGOUT" && handlers.onLogout) {
            handlers.onLogout();
        }
    };
};
